import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { faCog } from '@fortawesome/pro-solid-svg-icons'

import IconButton from 'components/ui/icon-button/IconButton'
import { Sort } from 'components/FolderSortConfiguration'
import { IMainState } from 'store/states'
import { IFolderSortSettingsField } from 'models/folder.model'
import { IGeneralAPI } from 'store/states/general.state'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import styles from './Config.module.scss'

interface ConfigProps {
  update: (data: Partial<IGeneralAPI>) => void
  disabled?: boolean
  modalTitle?: string
}

export const Config = ({ update, disabled, modalTitle }: ConfigProps) => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)
  const { folders } = useSelector(({ general }: IMainState) => general.settings)

  const onClose = () => {
    setShow(false)
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <CommonToolTip
        text={t('administration.folders.buttons.orderFolders')}
        position="top"
      >
        <IconButton
          icon={faCog}
          className={styles.config}
          onClick={() => {
            setShow(true)
          }}
          disabled={disabled}
        />
      </CommonToolTip>
      <Sort
        show={show}
        onClose={onClose}
        onSave={async (fields) => {
          const fieldsSortConfiguration: IFolderSortSettingsField[] = []
          for (const { option, direction } of fields)
            if (option)
              fieldsSortConfiguration.push({
                attribute: option.value,
                direction,
              })
          update({
            foldersSettings: {
              sort: {
                fields: fieldsSortConfiguration,
              },
            },
          })
          onClose()
        }}
        sortSettings={folders?.sort}
        modalTitle={modalTitle}
      />
    </div>
  )
}
